import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDrAnswer, IAuthReduxProps, ITarget, IVente } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { answerDr } from '../../flux/actions/drActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faExternalLinkAlt, faPen, faSpinner, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import { getConstanteProjetInfos, getConstanteRecuImageIncrem } from '../../flux/actions/constanteActions';
import { instantUploadToFTP } from '../pdf/PDFLink';
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges';
import { createPlaceholderDrive } from '../../flux/actions/venteActions';

const DrDelete = ({
  modal,
  setModal,
  handleToggle,
  modalDr,
  answerDr,
  answer,
  auth
 }: IDrAnswer) => {
  const [idValue, setIdValue] = useState(-1);
  const [venteValue, setVenteValue] = useState<IVente | undefined>();
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const alert = useAlert();

  const modalOpenedHandle = () => {
    if(modalDr && modalDr !== ''){
      setIdValue(modalDr["id"]);
      setVenteValue(modalDr["contrat"]);
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setVenteValue(undefined);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success, approved) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success(`Demande ${approved ? "acceptée" : "refusée"} avec succès`);
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const answerHandle = async () => {
    if(idValue === -1 || !venteValue)
      return
    const isDg = auth?.user?.speciality === constants.ROLE_DG ? 1 : 0;
    const isDc = auth?.user?.speciality === constants.ROLE_DC ? 1 : 0;
    const isWb = auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER) ? 1 : 0;
    if(isDg === 0 && isDc === 0 && isWb === 0){
      alert.error("Action non autorisée")
      return
    }
    setDisableSubmit(true);
    let recu_image_counter: any = null;
    let recuFile: any = null;
    let placeholderData
    if(answer === 1){
      const constantesProjet = await getConstanteProjetInfos(venteValue.IDPROJET || -1, venteValue.PROJET || "");
      recu_image_counter = await getConstanteRecuImageIncrem();

      placeholderData = await createPlaceholderDrive(null, 1, recu_image_counter, "R", venteValue.id || -1, venteValue.ID_BIEN || -1, venteValue.TYPE_VENTE === "ASSOCIATION" ? 1 : 0, null, 1, 1, auth?.user?.id)
      if(!placeholderData?.fileId || !placeholderData?.webViewLink || !placeholderData?.recuId){
        alert.error("No placeholder")
        setDisableSubmit(false)
        return
      }

      recuFile = await instantUploadToFTP({
        documentType: "recu",
        data: {...venteValue, REMISE_VALIDEE: answer, ...(answer === 1 ? {PRIX_NET: (venteValue.PRIX_M_CLIENT || venteValue.PRIX_BIEN || 0) - (venteValue.REMISE || 0)} : {}), ...(answer === 1 && venteValue.SUPERFICIE ? {PRIX_M: Number((((venteValue.PRIX_M_CLIENT || venteValue.PRIX_BIEN || 0) - (venteValue.REMISE || 0)) / venteValue.SUPERFICIE).toFixed(2))} : {}), recu_image_counter, association: venteValue.TYPE_VENTE === "ASSOCIATION", constantesProjet, webViewLink: placeholderData.webViewLink, authUserId: auth?.user?.id},
        showPreviewWatermark: false,
      });
    }
    answerDr(idValue, venteValue.id || -1, venteValue.ID_BIEN || -1, venteValue.ID_COM || -1, venteValue.COMMERCIAL || "-", answer, isDg, isDc, isWb, recuFile, placeholderData.recuId, placeholderData.fileId, recu_image_counter, venteValue.TYPE_VENTE === "ASSOCIATION" ? 1 : 0, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faCheckCircle} />&nbsp;&nbsp;Demande de Remise</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  Voulez-vous vraiment <b>{answer ? "accepter" : "refuser"}</b> la demande de remise du bien <b>{venteValue ? venteValue["DESIGNATION"] : ""}</b> ?
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className={`btn btn-${answer ? "success" : "danger"} linesConfirmationBtn linesDeleteBtn`}
                  onClick={answerHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;{answer ? "Accepter" : "Refuser"}</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { answerDr })(DrDelete);
